/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as SignInRouteImport } from "./routes/sign-in"
import { Route as InviteTokenRouteImport } from "./routes/invite.$token"
import { Route as WWorkspaceRouteImport } from "./routes/w.$workspace"
import { Route as WorkspacesNewRouteImport } from "./routes/workspaces.new"
import { Route as WWorkspaceIndexRouteImport } from "./routes/w.$workspace.index"
import { Route as WWorkspaceWsRouteImport } from "./routes/w.$workspace._ws"
import { Route as WWorkspaceWsSectionRouteImport } from "./routes/w.$workspace._ws.$section"
import { Route as WWorkspacePProjectRouteImport } from "./routes/w.$workspace.p.$project"
import { Route as WWorkspaceWsProjectsNewRouteImport } from "./routes/w.$workspace._ws.projects.new"
import { Route as WWorkspacePProjectIndexRouteImport } from "./routes/w.$workspace.p.$project.index"
import { Route as WWorkspacePProjectSplatRouteImport } from "./routes/w.$workspace.p.$project.$"
import { Route as WWorkspacePProjectAlertsRouteImport } from "./routes/w.$workspace.p.$project.alerts"
import { Route as WWorkspacePProjectEnvironmentsRouteImport } from "./routes/w.$workspace.p.$project.environments"
import { Route as WWorkspacePProjectIssuesRouteImport } from "./routes/w.$workspace.p.$project.issues"
import { Route as WWorkspacePProjectLineageRouteImport } from "./routes/w.$workspace.p.$project.lineage"
import { Route as WWorkspacePProjectRepositoryRouteImport } from "./routes/w.$workspace.p.$project.repository"
import { Route as WWorkspacePProjectSettingsRouteImport } from "./routes/w.$workspace.p.$project.settings"
import { Route as WWorkspacePProjectSourcesRouteImport } from "./routes/w.$workspace.p.$project.sources"
import { Route as WWorkspacePProjectTestsRouteImport } from "./routes/w.$workspace.p.$project.tests"
import { Route as WWorkspacePProjectJobsIndexRouteImport } from "./routes/w.$workspace.p.$project.jobs.index"
import { Route as WWorkspacePProjectJobsJobIdRouteImport } from "./routes/w.$workspace.p.$project.jobs.$jobId"
import { Route as WWorkspacePProjectModelsModelRouteImport } from "./routes/w.$workspace.p.$project.models.$model"
import { Route as WWorkspacePProjectRunsIndexRouteImport } from "./routes/w.$workspace.p.$project.runs.index"
import { Route as WWorkspacePProjectRunsRunIdRouteImport } from "./routes/w.$workspace.p.$project.runs.$runId"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: "/invite/$token",
  path: "/invite/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceRoute = WWorkspaceRouteImport.update({
  id: "/w/$workspace",
  path: "/w/$workspace",
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesNewRoute = WorkspacesNewRouteImport.update({
  id: "/workspaces/new",
  path: "/workspaces/new",
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIndexRoute = WWorkspaceIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceWsRoute = WWorkspaceWsRouteImport.update({
  id: "/_ws",
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceWsSectionRoute = WWorkspaceWsSectionRouteImport.update({
  id: "/$section",
  path: "/$section",
  getParentRoute: () => WWorkspaceWsRoute,
} as any)
const WWorkspacePProjectRoute = WWorkspacePProjectRouteImport.update({
  id: "/p/$project",
  path: "/p/$project",
  getParentRoute: () => WWorkspaceRoute,
} as any)
const WWorkspaceWsProjectsNewRoute = WWorkspaceWsProjectsNewRouteImport.update({
  id: "/projects/new",
  path: "/projects/new",
  getParentRoute: () => WWorkspaceWsRoute,
} as any)
const WWorkspacePProjectIndexRoute = WWorkspacePProjectIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => WWorkspacePProjectRoute,
} as any)
const WWorkspacePProjectSplatRoute = WWorkspacePProjectSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => WWorkspacePProjectRoute,
} as any)
const WWorkspacePProjectAlertsRoute =
  WWorkspacePProjectAlertsRouteImport.update({
    id: "/alerts",
    path: "/alerts",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectEnvironmentsRoute =
  WWorkspacePProjectEnvironmentsRouteImport.update({
    id: "/environments",
    path: "/environments",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectIssuesRoute =
  WWorkspacePProjectIssuesRouteImport.update({
    id: "/issues",
    path: "/issues",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectLineageRoute =
  WWorkspacePProjectLineageRouteImport.update({
    id: "/lineage",
    path: "/lineage",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectRepositoryRoute =
  WWorkspacePProjectRepositoryRouteImport.update({
    id: "/repository",
    path: "/repository",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectSettingsRoute =
  WWorkspacePProjectSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectSourcesRoute =
  WWorkspacePProjectSourcesRouteImport.update({
    id: "/sources",
    path: "/sources",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectTestsRoute = WWorkspacePProjectTestsRouteImport.update({
  id: "/tests",
  path: "/tests",
  getParentRoute: () => WWorkspacePProjectRoute,
} as any)
const WWorkspacePProjectJobsIndexRoute =
  WWorkspacePProjectJobsIndexRouteImport.update({
    id: "/jobs/",
    path: "/jobs/",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectJobsJobIdRoute =
  WWorkspacePProjectJobsJobIdRouteImport.update({
    id: "/jobs/$jobId",
    path: "/jobs/$jobId",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectModelsModelRoute =
  WWorkspacePProjectModelsModelRouteImport.update({
    id: "/models/$model",
    path: "/models/$model",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectRunsIndexRoute =
  WWorkspacePProjectRunsIndexRouteImport.update({
    id: "/runs/",
    path: "/runs/",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)
const WWorkspacePProjectRunsRunIdRoute =
  WWorkspacePProjectRunsRunIdRouteImport.update({
    id: "/runs/$runId",
    path: "/runs/$runId",
    getParentRoute: () => WWorkspacePProjectRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/sign-in": typeof SignInRoute
  "/invite/$token": typeof InviteTokenRoute
  "/w/$workspace": typeof WWorkspaceRouteWithChildren
  "/workspaces/new": typeof WorkspacesNewRoute
  "/w/$workspace/": typeof WWorkspaceIndexRoute
  "/w/$workspace/$section": typeof WWorkspaceWsSectionRoute
  "/w/$workspace/p/$project": typeof WWorkspacePProjectRouteWithChildren
  "/w/$workspace/projects/new": typeof WWorkspaceWsProjectsNewRoute
  "/w/$workspace/p/$project/$": typeof WWorkspacePProjectSplatRoute
  "/w/$workspace/p/$project/alerts": typeof WWorkspacePProjectAlertsRoute
  "/w/$workspace/p/$project/environments": typeof WWorkspacePProjectEnvironmentsRoute
  "/w/$workspace/p/$project/issues": typeof WWorkspacePProjectIssuesRoute
  "/w/$workspace/p/$project/lineage": typeof WWorkspacePProjectLineageRoute
  "/w/$workspace/p/$project/repository": typeof WWorkspacePProjectRepositoryRoute
  "/w/$workspace/p/$project/settings": typeof WWorkspacePProjectSettingsRoute
  "/w/$workspace/p/$project/sources": typeof WWorkspacePProjectSourcesRoute
  "/w/$workspace/p/$project/tests": typeof WWorkspacePProjectTestsRoute
  "/w/$workspace/p/$project/": typeof WWorkspacePProjectIndexRoute
  "/w/$workspace/p/$project/jobs/$jobId": typeof WWorkspacePProjectJobsJobIdRoute
  "/w/$workspace/p/$project/models/$model": typeof WWorkspacePProjectModelsModelRoute
  "/w/$workspace/p/$project/runs/$runId": typeof WWorkspacePProjectRunsRunIdRoute
  "/w/$workspace/p/$project/jobs/": typeof WWorkspacePProjectJobsIndexRoute
  "/w/$workspace/p/$project/runs/": typeof WWorkspacePProjectRunsIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/sign-in": typeof SignInRoute
  "/invite/$token": typeof InviteTokenRoute
  "/workspaces/new": typeof WorkspacesNewRoute
  "/w/$workspace": typeof WWorkspaceIndexRoute
  "/w/$workspace/$section": typeof WWorkspaceWsSectionRoute
  "/w/$workspace/projects/new": typeof WWorkspaceWsProjectsNewRoute
  "/w/$workspace/p/$project/$": typeof WWorkspacePProjectSplatRoute
  "/w/$workspace/p/$project/alerts": typeof WWorkspacePProjectAlertsRoute
  "/w/$workspace/p/$project/environments": typeof WWorkspacePProjectEnvironmentsRoute
  "/w/$workspace/p/$project/issues": typeof WWorkspacePProjectIssuesRoute
  "/w/$workspace/p/$project/lineage": typeof WWorkspacePProjectLineageRoute
  "/w/$workspace/p/$project/repository": typeof WWorkspacePProjectRepositoryRoute
  "/w/$workspace/p/$project/settings": typeof WWorkspacePProjectSettingsRoute
  "/w/$workspace/p/$project/sources": typeof WWorkspacePProjectSourcesRoute
  "/w/$workspace/p/$project/tests": typeof WWorkspacePProjectTestsRoute
  "/w/$workspace/p/$project": typeof WWorkspacePProjectIndexRoute
  "/w/$workspace/p/$project/jobs/$jobId": typeof WWorkspacePProjectJobsJobIdRoute
  "/w/$workspace/p/$project/models/$model": typeof WWorkspacePProjectModelsModelRoute
  "/w/$workspace/p/$project/runs/$runId": typeof WWorkspacePProjectRunsRunIdRoute
  "/w/$workspace/p/$project/jobs": typeof WWorkspacePProjectJobsIndexRoute
  "/w/$workspace/p/$project/runs": typeof WWorkspacePProjectRunsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/sign-in": typeof SignInRoute
  "/invite/$token": typeof InviteTokenRoute
  "/w/$workspace": typeof WWorkspaceRouteWithChildren
  "/workspaces/new": typeof WorkspacesNewRoute
  "/w/$workspace/_ws": typeof WWorkspaceWsRouteWithChildren
  "/w/$workspace/": typeof WWorkspaceIndexRoute
  "/w/$workspace/_ws/$section": typeof WWorkspaceWsSectionRoute
  "/w/$workspace/p/$project": typeof WWorkspacePProjectRouteWithChildren
  "/w/$workspace/_ws/projects/new": typeof WWorkspaceWsProjectsNewRoute
  "/w/$workspace/p/$project/$": typeof WWorkspacePProjectSplatRoute
  "/w/$workspace/p/$project/alerts": typeof WWorkspacePProjectAlertsRoute
  "/w/$workspace/p/$project/environments": typeof WWorkspacePProjectEnvironmentsRoute
  "/w/$workspace/p/$project/issues": typeof WWorkspacePProjectIssuesRoute
  "/w/$workspace/p/$project/lineage": typeof WWorkspacePProjectLineageRoute
  "/w/$workspace/p/$project/repository": typeof WWorkspacePProjectRepositoryRoute
  "/w/$workspace/p/$project/settings": typeof WWorkspacePProjectSettingsRoute
  "/w/$workspace/p/$project/sources": typeof WWorkspacePProjectSourcesRoute
  "/w/$workspace/p/$project/tests": typeof WWorkspacePProjectTestsRoute
  "/w/$workspace/p/$project/": typeof WWorkspacePProjectIndexRoute
  "/w/$workspace/p/$project/jobs/$jobId": typeof WWorkspacePProjectJobsJobIdRoute
  "/w/$workspace/p/$project/models/$model": typeof WWorkspacePProjectModelsModelRoute
  "/w/$workspace/p/$project/runs/$runId": typeof WWorkspacePProjectRunsRunIdRoute
  "/w/$workspace/p/$project/jobs/": typeof WWorkspacePProjectJobsIndexRoute
  "/w/$workspace/p/$project/runs/": typeof WWorkspacePProjectRunsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/sign-in"
    | "/invite/$token"
    | "/w/$workspace"
    | "/workspaces/new"
    | "/w/$workspace/"
    | "/w/$workspace/$section"
    | "/w/$workspace/p/$project"
    | "/w/$workspace/projects/new"
    | "/w/$workspace/p/$project/$"
    | "/w/$workspace/p/$project/alerts"
    | "/w/$workspace/p/$project/environments"
    | "/w/$workspace/p/$project/issues"
    | "/w/$workspace/p/$project/lineage"
    | "/w/$workspace/p/$project/repository"
    | "/w/$workspace/p/$project/settings"
    | "/w/$workspace/p/$project/sources"
    | "/w/$workspace/p/$project/tests"
    | "/w/$workspace/p/$project/"
    | "/w/$workspace/p/$project/jobs/$jobId"
    | "/w/$workspace/p/$project/models/$model"
    | "/w/$workspace/p/$project/runs/$runId"
    | "/w/$workspace/p/$project/jobs/"
    | "/w/$workspace/p/$project/runs/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/sign-in"
    | "/invite/$token"
    | "/workspaces/new"
    | "/w/$workspace"
    | "/w/$workspace/$section"
    | "/w/$workspace/projects/new"
    | "/w/$workspace/p/$project/$"
    | "/w/$workspace/p/$project/alerts"
    | "/w/$workspace/p/$project/environments"
    | "/w/$workspace/p/$project/issues"
    | "/w/$workspace/p/$project/lineage"
    | "/w/$workspace/p/$project/repository"
    | "/w/$workspace/p/$project/settings"
    | "/w/$workspace/p/$project/sources"
    | "/w/$workspace/p/$project/tests"
    | "/w/$workspace/p/$project"
    | "/w/$workspace/p/$project/jobs/$jobId"
    | "/w/$workspace/p/$project/models/$model"
    | "/w/$workspace/p/$project/runs/$runId"
    | "/w/$workspace/p/$project/jobs"
    | "/w/$workspace/p/$project/runs"
  id:
    | "__root__"
    | "/"
    | "/sign-in"
    | "/invite/$token"
    | "/w/$workspace"
    | "/workspaces/new"
    | "/w/$workspace/_ws"
    | "/w/$workspace/"
    | "/w/$workspace/_ws/$section"
    | "/w/$workspace/p/$project"
    | "/w/$workspace/_ws/projects/new"
    | "/w/$workspace/p/$project/$"
    | "/w/$workspace/p/$project/alerts"
    | "/w/$workspace/p/$project/environments"
    | "/w/$workspace/p/$project/issues"
    | "/w/$workspace/p/$project/lineage"
    | "/w/$workspace/p/$project/repository"
    | "/w/$workspace/p/$project/settings"
    | "/w/$workspace/p/$project/sources"
    | "/w/$workspace/p/$project/tests"
    | "/w/$workspace/p/$project/"
    | "/w/$workspace/p/$project/jobs/$jobId"
    | "/w/$workspace/p/$project/models/$model"
    | "/w/$workspace/p/$project/runs/$runId"
    | "/w/$workspace/p/$project/jobs/"
    | "/w/$workspace/p/$project/runs/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SignInRoute: typeof SignInRoute
  InviteTokenRoute: typeof InviteTokenRoute
  WWorkspaceRoute: typeof WWorkspaceRouteWithChildren
  WorkspacesNewRoute: typeof WorkspacesNewRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sign-in": {
      id: "/sign-in"
      path: "/sign-in"
      fullPath: "/sign-in"
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/invite/$token": {
      id: "/invite/$token"
      path: "/invite/$token"
      fullPath: "/invite/$token"
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/w/$workspace": {
      id: "/w/$workspace"
      path: "/w/$workspace"
      fullPath: "/w/$workspace"
      preLoaderRoute: typeof WWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/workspaces/new": {
      id: "/workspaces/new"
      path: "/workspaces/new"
      fullPath: "/workspaces/new"
      preLoaderRoute: typeof WorkspacesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/w/$workspace/": {
      id: "/w/$workspace/"
      path: "/"
      fullPath: "/w/$workspace/"
      preLoaderRoute: typeof WWorkspaceIndexRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    "/w/$workspace/_ws": {
      id: "/w/$workspace/_ws"
      path: ""
      fullPath: "/w/$workspace"
      preLoaderRoute: typeof WWorkspaceWsRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    "/w/$workspace/_ws/$section": {
      id: "/w/$workspace/_ws/$section"
      path: "/$section"
      fullPath: "/w/$workspace/$section"
      preLoaderRoute: typeof WWorkspaceWsSectionRouteImport
      parentRoute: typeof WWorkspaceWsRoute
    }
    "/w/$workspace/p/$project": {
      id: "/w/$workspace/p/$project"
      path: "/p/$project"
      fullPath: "/w/$workspace/p/$project"
      preLoaderRoute: typeof WWorkspacePProjectRouteImport
      parentRoute: typeof WWorkspaceRoute
    }
    "/w/$workspace/_ws/projects/new": {
      id: "/w/$workspace/_ws/projects/new"
      path: "/projects/new"
      fullPath: "/w/$workspace/projects/new"
      preLoaderRoute: typeof WWorkspaceWsProjectsNewRouteImport
      parentRoute: typeof WWorkspaceWsRoute
    }
    "/w/$workspace/p/$project/": {
      id: "/w/$workspace/p/$project/"
      path: "/"
      fullPath: "/w/$workspace/p/$project/"
      preLoaderRoute: typeof WWorkspacePProjectIndexRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/$": {
      id: "/w/$workspace/p/$project/$"
      path: "/$"
      fullPath: "/w/$workspace/p/$project/$"
      preLoaderRoute: typeof WWorkspacePProjectSplatRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/alerts": {
      id: "/w/$workspace/p/$project/alerts"
      path: "/alerts"
      fullPath: "/w/$workspace/p/$project/alerts"
      preLoaderRoute: typeof WWorkspacePProjectAlertsRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/environments": {
      id: "/w/$workspace/p/$project/environments"
      path: "/environments"
      fullPath: "/w/$workspace/p/$project/environments"
      preLoaderRoute: typeof WWorkspacePProjectEnvironmentsRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/issues": {
      id: "/w/$workspace/p/$project/issues"
      path: "/issues"
      fullPath: "/w/$workspace/p/$project/issues"
      preLoaderRoute: typeof WWorkspacePProjectIssuesRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/lineage": {
      id: "/w/$workspace/p/$project/lineage"
      path: "/lineage"
      fullPath: "/w/$workspace/p/$project/lineage"
      preLoaderRoute: typeof WWorkspacePProjectLineageRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/repository": {
      id: "/w/$workspace/p/$project/repository"
      path: "/repository"
      fullPath: "/w/$workspace/p/$project/repository"
      preLoaderRoute: typeof WWorkspacePProjectRepositoryRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/settings": {
      id: "/w/$workspace/p/$project/settings"
      path: "/settings"
      fullPath: "/w/$workspace/p/$project/settings"
      preLoaderRoute: typeof WWorkspacePProjectSettingsRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/sources": {
      id: "/w/$workspace/p/$project/sources"
      path: "/sources"
      fullPath: "/w/$workspace/p/$project/sources"
      preLoaderRoute: typeof WWorkspacePProjectSourcesRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/tests": {
      id: "/w/$workspace/p/$project/tests"
      path: "/tests"
      fullPath: "/w/$workspace/p/$project/tests"
      preLoaderRoute: typeof WWorkspacePProjectTestsRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/jobs/": {
      id: "/w/$workspace/p/$project/jobs/"
      path: "/jobs"
      fullPath: "/w/$workspace/p/$project/jobs/"
      preLoaderRoute: typeof WWorkspacePProjectJobsIndexRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/jobs/$jobId": {
      id: "/w/$workspace/p/$project/jobs/$jobId"
      path: "/jobs/$jobId"
      fullPath: "/w/$workspace/p/$project/jobs/$jobId"
      preLoaderRoute: typeof WWorkspacePProjectJobsJobIdRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/models/$model": {
      id: "/w/$workspace/p/$project/models/$model"
      path: "/models/$model"
      fullPath: "/w/$workspace/p/$project/models/$model"
      preLoaderRoute: typeof WWorkspacePProjectModelsModelRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/runs/": {
      id: "/w/$workspace/p/$project/runs/"
      path: "/runs"
      fullPath: "/w/$workspace/p/$project/runs/"
      preLoaderRoute: typeof WWorkspacePProjectRunsIndexRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
    "/w/$workspace/p/$project/runs/$runId": {
      id: "/w/$workspace/p/$project/runs/$runId"
      path: "/runs/$runId"
      fullPath: "/w/$workspace/p/$project/runs/$runId"
      preLoaderRoute: typeof WWorkspacePProjectRunsRunIdRouteImport
      parentRoute: typeof WWorkspacePProjectRoute
    }
  }
}

interface WWorkspaceWsRouteChildren {
  WWorkspaceWsSectionRoute: typeof WWorkspaceWsSectionRoute
  WWorkspaceWsProjectsNewRoute: typeof WWorkspaceWsProjectsNewRoute
}

const WWorkspaceWsRouteChildren: WWorkspaceWsRouteChildren = {
  WWorkspaceWsSectionRoute: WWorkspaceWsSectionRoute,
  WWorkspaceWsProjectsNewRoute: WWorkspaceWsProjectsNewRoute,
}

const WWorkspaceWsRouteWithChildren = WWorkspaceWsRoute._addFileChildren(
  WWorkspaceWsRouteChildren,
)

interface WWorkspacePProjectRouteChildren {
  WWorkspacePProjectSplatRoute: typeof WWorkspacePProjectSplatRoute
  WWorkspacePProjectAlertsRoute: typeof WWorkspacePProjectAlertsRoute
  WWorkspacePProjectEnvironmentsRoute: typeof WWorkspacePProjectEnvironmentsRoute
  WWorkspacePProjectIssuesRoute: typeof WWorkspacePProjectIssuesRoute
  WWorkspacePProjectLineageRoute: typeof WWorkspacePProjectLineageRoute
  WWorkspacePProjectRepositoryRoute: typeof WWorkspacePProjectRepositoryRoute
  WWorkspacePProjectSettingsRoute: typeof WWorkspacePProjectSettingsRoute
  WWorkspacePProjectSourcesRoute: typeof WWorkspacePProjectSourcesRoute
  WWorkspacePProjectTestsRoute: typeof WWorkspacePProjectTestsRoute
  WWorkspacePProjectIndexRoute: typeof WWorkspacePProjectIndexRoute
  WWorkspacePProjectJobsJobIdRoute: typeof WWorkspacePProjectJobsJobIdRoute
  WWorkspacePProjectModelsModelRoute: typeof WWorkspacePProjectModelsModelRoute
  WWorkspacePProjectRunsRunIdRoute: typeof WWorkspacePProjectRunsRunIdRoute
  WWorkspacePProjectJobsIndexRoute: typeof WWorkspacePProjectJobsIndexRoute
  WWorkspacePProjectRunsIndexRoute: typeof WWorkspacePProjectRunsIndexRoute
}

const WWorkspacePProjectRouteChildren: WWorkspacePProjectRouteChildren = {
  WWorkspacePProjectSplatRoute: WWorkspacePProjectSplatRoute,
  WWorkspacePProjectAlertsRoute: WWorkspacePProjectAlertsRoute,
  WWorkspacePProjectEnvironmentsRoute: WWorkspacePProjectEnvironmentsRoute,
  WWorkspacePProjectIssuesRoute: WWorkspacePProjectIssuesRoute,
  WWorkspacePProjectLineageRoute: WWorkspacePProjectLineageRoute,
  WWorkspacePProjectRepositoryRoute: WWorkspacePProjectRepositoryRoute,
  WWorkspacePProjectSettingsRoute: WWorkspacePProjectSettingsRoute,
  WWorkspacePProjectSourcesRoute: WWorkspacePProjectSourcesRoute,
  WWorkspacePProjectTestsRoute: WWorkspacePProjectTestsRoute,
  WWorkspacePProjectIndexRoute: WWorkspacePProjectIndexRoute,
  WWorkspacePProjectJobsJobIdRoute: WWorkspacePProjectJobsJobIdRoute,
  WWorkspacePProjectModelsModelRoute: WWorkspacePProjectModelsModelRoute,
  WWorkspacePProjectRunsRunIdRoute: WWorkspacePProjectRunsRunIdRoute,
  WWorkspacePProjectJobsIndexRoute: WWorkspacePProjectJobsIndexRoute,
  WWorkspacePProjectRunsIndexRoute: WWorkspacePProjectRunsIndexRoute,
}

const WWorkspacePProjectRouteWithChildren =
  WWorkspacePProjectRoute._addFileChildren(WWorkspacePProjectRouteChildren)

interface WWorkspaceRouteChildren {
  WWorkspaceWsRoute: typeof WWorkspaceWsRouteWithChildren
  WWorkspaceIndexRoute: typeof WWorkspaceIndexRoute
  WWorkspacePProjectRoute: typeof WWorkspacePProjectRouteWithChildren
}

const WWorkspaceRouteChildren: WWorkspaceRouteChildren = {
  WWorkspaceWsRoute: WWorkspaceWsRouteWithChildren,
  WWorkspaceIndexRoute: WWorkspaceIndexRoute,
  WWorkspacePProjectRoute: WWorkspacePProjectRouteWithChildren,
}

const WWorkspaceRouteWithChildren = WWorkspaceRoute._addFileChildren(
  WWorkspaceRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SignInRoute: SignInRoute,
  InviteTokenRoute: InviteTokenRoute,
  WWorkspaceRoute: WWorkspaceRouteWithChildren,
  WorkspacesNewRoute: WorkspacesNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
